// extracted by mini-css-extract-plugin
export default {"country":"aVXMzx","country--active":"bsaJg7","flag":"RPgmKD","flex":"uxmLZM","arrow-pointer":"zu94Dz"};